import staticConfig from "./staticConfig";
// const dmi = '//dmi.dev.datatellit.com'
// const ds = '//dataservice.dev.datatellit.com'
// const iot = '//iot.dev.datatellit.com'
const dmi = "//dmi.datatellit.com"; // '//192.168.2.137:8082' ||
const ds = "//dataservice.datatellit.com";
const iot = "//iot.datatellit.com";
const service = "//service.datatellit.com";
const otherControl = "https://business.alm-iot.com";
const zzt = "//zeocor.z-things.com:1900";
// const dmi = window.statics.dmi
// const ds = window.statics.ds
// const iot = window.statics.iot
// const dmi_localhost = window.statics.dmi_localhost
export default {
  name: "智慧环境中控系统",
  dmi,
  ds,
  iot,
  staticConfig,
  api: {
    login: `${dmi}/users/login`,
    faceLogin: `${dmi}/teachers/login`,
    zone: `${dmi}/zoneusers/getzonebyparams`,
    zoneTree: `${dmi}/zones/:zoneId/tree`,
    subject: `${dmi}/subjectschedules/getsubjectbyzoneId/:zoneId`,
    scene: `${dmi}/zones/:zoneId/scene`,
    sceneVisible: `${dmi}/zones/:zoneId/scenes/visible`,
    notify: `${dmi}/schoolnotices/getnoticebyzoneId/:zoneId`,
    device: `${dmi}/zonedevices/getalldevicebyzoneid/:zoneId`,
    light: `${dmi}/zones/:zoneId/devices/deviceNodes`,
    extDevice: `${dmi}/zones/:zoneId/devices/extDevices`,
    config: `${dmi}/systemconfigs/`,
    // weather: `${dmi}/zones/weather/:zoneId`,
    weather: `${service}/open/weather`, // 使用新的天气接口
    sensor: `${dmi}/devices/state`,
    activeScene: `${dmi}/scenes/:sceneId/active`,
    socket: `${ds}/event`,
    control: `${iot}/dcioperates`,
    systemConfig: `${dmi}/systemconfigs`,
    report: `${dmi}/usersoperates`,
    scenes: `${dmi}/scenes`,
    zoneConfig: `${dmi}/zoneconfigs`,
    nodes: `${dmi}/devicenodes`,
    extDevices: `${dmi}/extdevices`,
    otherExtDevice: `${dmi}/zones/:zoneId/devices/otherDevices`,
    otherDeviceToken: `${dmi}/otherExtDevices/token`,
    status: `${dmi}/devices/status`,
    otherControl: `${otherControl}/sendDevCommandOfDevMeter`,
    otherExtState: `${otherControl}/getDevMeterCurrentData`,
    lockControl: `${zzt}/lock/control`,
    lockState: `${ds}/lock/state`,
  },
  defaultState: {
    aircon: { air: 1, mode: 0, state: 0, tt: 26 },
    airpure: { state: 0, air: 2 },
    curtain: { state: 0 },
    fan: { state: 0, air: 2 },
    colorbar: { state: 0, color: "white" },
    switch: { state: 0 },
    remote: {},
    sensor: {},
    airswitch: {},
  },
  v1: "http://boardv1.dev.datatellit.com",
  assetsHost: dmi,
  monitor: [
    {
      no: "szsy/0002",
      src: ["rtmp://live.datatellit.com/live/00dfb62dbe", "//live.datatellit.com/live/00dfb62dbe.flv", "//live.datatellit.com/live/00dfb62dbe.m3u8"],
    },
  ],
  timing: 2000,
};
